import store from '@/store'

const docTitleHandler = title => {
  const BASE_TITLE = store.getters['appConfig/getAppName']

  document.title = BASE_TITLE + (title ? ` - ${title}` : '')
}

export {
  docTitleHandler
}